var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInboxIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 17,
    fill: "none",
    viewBox: "0 0 20 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M16.429 16.394H3.57c-.947 0-1.855-.432-2.525-1.2C.376 14.425 0 13.382 0 12.295V4.098C0 3.011.376 1.968 1.046 1.2 1.716.431 2.624 0 3.571 0H16.43c.947 0 1.855.431 2.525 1.2.67.769 1.046 1.811 1.046 2.898v8.197c0 1.088-.376 2.13-1.046 2.899-.67.768-1.578 1.2-2.525 1.2ZM3.57 1.64c-.568 0-1.113.26-1.515.72A2.655 2.655 0 0 0 1.43 4.1v8.196c0 .653.225 1.278.627 1.74.402.46.947.72 1.515.72H16.43c.568 0 1.113-.26 1.515-.72a2.654 2.654 0 0 0 .627-1.74V4.098c0-.652-.225-1.278-.627-1.739-.402-.46-.947-.72-1.515-.72H3.57Zm6.78 7.27 6.429-4.099a.817.817 0 0 0 .334-.498.93.93 0 0 0-.07-.625.74.74 0 0 0-.435-.384.637.637 0 0 0-.544.081L10 7.262 3.921 3.385a.628.628 0 0 0-.544-.08.685.685 0 0 0-.25.142.8.8 0 0 0-.184.241.94.94 0 0 0-.07.624c.049.211.17.39.334.5L6.421 6.86l3.215 2.05c.108.072.231.11.357.11a.645.645 0 0 0 .357-.11Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInboxIcon);
export default __webpack_public_path__ + "static/media/inbox-icon.b426b3a3d785545220a14dc3b2b39b91.svg";
export { ForwardRef as ReactComponent };